import { FormControl, Validators } from '@angular/forms';
import { Note } from '../note';

export class NoteForm {
    Seq = new FormControl();
    Selected = new FormControl();
    TextArea = new FormControl();

    constructor(note: Note) {
        this.Seq.setValue(note.Seq);

        if (note.Selected) {
            this.Selected.setValue(note.Selected);
            this.TextArea.setValue(note.TextArea);
        }
    }
}
